import { IAppState } from "../index.state";

export const spinnerSelector = (state: IAppState) => state.layout?.showSpinner;
export const sidePanelSelector = (state: IAppState) => state.layout?.showSidePanel;
